import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// Import local translation files
import enTranslations from '../i18n/translations/en.json'
import esTranslations from '../i18n/translations/es.json'
import deTranslations from '../i18n/translations/de.json'
import frTranslations from '../i18n/translations/fr.json'
import glTranslations from '../i18n/translations/gl.json'
import itTranslations from '../i18n/translations/it.json'
import nlTranslations from '../i18n/translations/nl.json'
import ptTranslations from '../i18n/translations/pt.json'

const resources = {
  en: { translation: enTranslations },
  es: { translation: esTranslations },
  de: { translation: deTranslations },
  fr: { translation: frTranslations },
  gl: { translation: glTranslations },
  it: { translation: itTranslations },
  nl: { translation: nlTranslations },
  pt: { translation: ptTranslations },
}

// Register every top-level object in a locale bundle as its own i18next
// namespace, in addition to the flat `translation` namespace.
//
// Components call `useTranslation("referral")` / `("jobs")` / `("common")` and
// then `t("title")`, but all keys actually live nested under the single
// `translation` namespace as `referral.title` etc. Without this step i18next
// has no `referral` namespace to resolve against, so every lookup falls through
// to the raw key — that is the "missing strings" bug on /dashboard/referral
// (regressed in the i18n rewrite of ReferralSystem, which added the namespace
// call but never registered the namespace). Both access patterns now work:
//   useTranslation("referral") + t("title")           ✓
//   useTranslation()           + t("referral.title")  ✓
// See i18n-namespace-registration.test.ts, which fails if any component
// requests a namespace this step does not register.
const nsResources = Object.fromEntries(
  Object.entries(resources).map(([lng, bundle]) => {
    const all = bundle.translation as Record<string, unknown>
    return [lng, { translation: all, ...all }]
  }),
)

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: nsResources,
    fallbackLng: 'en', // Fallback to English if locale not found
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  })

export default i18n
